/**
 * This class is auto generated by using the
 * "Dots.KLASIS.TsGenerator".
 * */
export const copyright = {

    label: {
        text: `{{year}} Centrālā statistikas pārvalde, Visas tiesības aizsargātas.`,
    },
}
